"use client";

import { TriangleAlert } from "lucide-react";

import { Response } from "@/components/ui/shadcn-io/ai/response";
import { cn } from "@/lib/utils";

interface CommandV2StreamErrorBannerProps {
    text: string;
    className?: string;
}

/**
 * A reply's warning or error (no subscription, out of credits, a tool failed): a small, calm
 * neutral note that sizes to its text. Only the icon carries the warning colour.
 */
export function CommandV2StreamErrorBanner({
    text,
    className,
}: CommandV2StreamErrorBannerProps) {
    return (
        <div
            role="alert"
            className={cn(
                "flex w-fit max-w-full items-start gap-2.5 rounded-[20px] border border-border bg-muted/50 px-4 py-2.5 text-foreground/80",
                "dark:bg-muted/40",
                className
            )}
        >
            <TriangleAlert aria-hidden strokeWidth={1.5} className="mt-[3px] size-4 shrink-0 text-[#C2491D] dark:text-[#FF6629]" />
            {/* The message is complete: no half-typed markdown to repair (that repair added a stray "_"). */}
            <Response
                parseIncompleteMarkdown={false}
                className="min-w-0 break-words text-sm leading-relaxed [&_a]:underline-offset-2 dark:[&_a]:text-[#D0BFFA] [&_p]:m-0 [&_strong]:font-semibold [&_strong]:text-foreground"
            >
                {text}
            </Response>
        </div>
    );
}
